import { Link } from "react-router-dom";
import styled from "styled-components";
import { IStyle, ButtonStyle } from "../../types";

const ButtonLinkStyle = styled(Link)<IStyle>`
  display: inline-block;
  color: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.contained
      ? props.theme.invertFontColor
      : props.theme.primaryColor};
  text-decoration: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.text ? "underline" : "none"};
  font-size: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.text ? "16px" : "14px"};
  padding: 12px
    ${(props) =>
      props.theme.buttonStyle === ButtonStyle.text ? "12px" : "24px"};
  background-color: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.contained
      ? props.theme.primaryColor
      : "transparent"};
  border: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.outlined
      ? `1px solid ${props.theme.primaryColor}`
      : "none"};
  box-shadow: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.text
      ? "0px 2px 4px rgba(0, 0, 0, 0.25)"
      : "none"};
  border-radius: 3px;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

export default ButtonLinkStyle;
